import { render, staticRenderFns } from "./ResultsPlaceholder.vue?vue&type=template&id=56576037"
import script from "./ResultsPlaceholder.vue?vue&type=script&lang=ts"
export * from "./ResultsPlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./ResultsPlaceholder.vue?vue&type=style&index=0&id=56576037&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseContainer: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseContainer.vue').default,BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default})
